import React, { useState } from 'react';


import { List } from 'immutable';
import { useSelector } from 'react-redux';

import './style.scss';

const MultiSelect = ({ values, setStoryTypeFilter }) => {
  const [options, setOptions] = useState([]);
  const terms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'story_types'], List()));

  // When item selected
  const onSelect = (value) => {
    const newOptions = [...options];
    if (newOptions.includes(value)) {
      // Remove if exists
      newOptions.splice(newOptions.indexOf(value), 1);
    } else {
      // Add if does not exists
      newOptions.push(value);
    }
    // Store data and set filters
    setOptions(newOptions);
    setStoryTypeFilter(newOptions);
  };

  return (
    <div className="MultiSelect">
      {terms.map((term) => {
        const val = term.getIn(['tid', 0, 'value']);
        return (
          <div
            key={val}
            className={`MultiSelect__option ${options.includes(val) ? 'active' : ''}`}
            onClick={() => {
              onSelect(term.getIn(['tid', 0, 'value']));
            }}
          >
            {term.getIn(['name', 0, 'value'])}
            <div className="icon icon-plus icon-variant-0" />
          </div>
        );
      })}
    </div>
  );
};

export default MultiSelect;
